export enum LanguagesWithRegions {
  RU_RU = 'ru-RU',
  EN_US = 'en-US',
  TR_TR = 'tr-TR',
}
